export default {
			'odkryj_dostep': 'Discover all categories and enjoy full access.',
			'odkryj_dostep_opis': 'Only one player pays and unlocks the game for both of them!',
			'kontynuuj_gre': 'Continue game',
            'zacznij_od_nowa': 'New game',
            'dolacz_do_gry': 'Join the game',
            'prosze_czekac': 'Please wait',
			
			
            'polski': 'Polski',
            'angielski': 'English',
            'hiszpanski': 'Español',
            'wloski': 'Italiano',
            'francuski': 'Français',
			'portugalski': 'Português',
			'niemiecki': 'Deutsch',
			
			
			
            'zamknij': '<i class="fa fa-times"></i> Close',
            'start_gry': "Start a game",
			'graj': 'Play',

			'wpisz_imiona_graczy':'Enter player names',
			'twoje_imie':'Your name',
			'imie_drugiego_gracza' :'Name of the other player',
			'wyslij_zaproszenie': 'Send invitation <i class="fas fa-chevron-right"></i>',
			'konfiguracja_polaczenia': 'Configuring connection',
			'daj_drugiemu': "Show below code to the other player and let he scan it",
			
			'poziomy': 'Categories',
			'rozpocznij_gre': 'Start game <i class="fas fa-chevron-right"></i>',
			'poziom1': 'Level 1',
			'poziom2': 'Level 2',
			'poziom3': 'Level 3',
			'oczekuje_na_druga_osobe': 'Waiting for second player',
			'oczekuje_na_druga_osobe_2': 'Waiting for second player',
			
			'graj_dalej': 'Continue game <i class="fas fa-chevron-right"></i>',
			'dokoncz_gre': 'Finish level <i class="fas fa-chevron-right"></i>',
			
			
			'odpowiadaj_na_pytania': 'Answer the questions',
			'pytanie': 'Question',
			'z':'from',
			'oczekuje_na_osobe': 'Waiting for answer second person',
			
			
			'wyniki_rozgrywki': "Game results",
			'gratulacje': "Congrats",
			'macie_zgodnosc': "You have compliance",
			'znasz_grugiego_gracza': "You know the other player on",
			'zna_ciebie': "knows you on",
			'jak_odpowiadaliscie': '<i class="fas fa-tasks"></i> See how you responded',
			'pochwal_sie': '<i class="fas fa-share-alt"></i> Share your result',
			
			'wasze_odpowiedzi': "Your answers",
			'skanuj_kod' :"Scan code",
			
			'statystyka': "Stats",
			'statystyka_gry': "Game stats",
			'powiadom': '<i class="fas fa-envelope" style="right:auto; left: 15px"></i> Notify about the new version',
			'zapisalismy_cie': 'We have saved your e-mail address',
			'rozpocznij': 'Start <i class="fas fa-chevron-right"></i>',
			'poznajcie_sie': "Get to know each other",
			'jak_znasz': "Matching Halves is a couples game that will show you how well you really know each other.",
			'help1': "You already have a game started. If you want to continue it - press the button below.",
			'help2': "However, you want to start new game or with a new player - press the button below.",
			'help3': "Be the first player to set up the game - add the names of the players and show generated code to the other player to scan.",
			'help4': "After the first player generates the code, press the button below and scan the code.",
			'help5': "After entering the names of the players, press the 'Send invitation' button and show the generated code to the other player for scan it",
			'help6': "Show below code to the other player for scan it",
			'help7': "Scan code shown by the other player",
			'kup': "Buy",
			
			'zagraj_ponownie': '<i class="fas fa-play" style="right:auto; left: 15px"></i> Play again',
			'opis_gry': 'Game description',
			'poziom': 'Level',
			'ext_desc': '<br>Matching Halves is a game for couples that will allow you to test how well you know your partner and how well he/she knows you.<br><br>One person starts the game by clicking on the "Start the game" button and enters your names.<br><br>The other person joins the game by clicking on the "Join the game" button and scans the code generated by the person starting the game. After scanning the code, the start of the game and the categories will be displayed on both players\' devices.<br><br>There are 6 categories, each with 3 levels of difficulty.  You start with the easiest one, level 1 (completing level 1 allows you to start the next level).<br><br>Don\'t let seemingly simple questions put you off, because the further you go the harder and spicier it gets!<br><br>At the same time, your phones or tablets will show you the same question, to which you answer yes/no or select a specific answer. All you need to do is click on the correct answer.<br><br>First you answer what your partner thinks, then you answer what you think. After completing each level, you can check how you answered and what percentage agreement you have with your partner.<br><br>You can pause the game at any time and complete it at a later date, but in the event that you start the game again, your previous answers will be deleted.<br><br>Have fun!<br><br><br><br>',
			'druga_osoba_odpowiedziala': 'Your pair is waiting for your answer',
			'confirm_text_1': 'Do you wanna start new game?',
			'confirm_text_2': 'You will lose your previous answers.',
			'yes_button': '<i class="fa fa-check "></i> Yes, start new game',
			'no_button': '<i class="fa fa-times"></i> No, I\'ll continue',
			'back' : '<i class="fas fa-chevron-left"></i> back',
			'backk' : '<i class="fas fa-chevron-left" style="right:auto;left:15px;"></i> Back',
			'podsumowanie_wynikow': 'Summary results<i class="fas fa-chevron-right"></i>',
			
			'Życie codzienne': 'Daily life',
			'Daily life': 'Daily life',
			'La vida cotidiana': 'Daily life',
			'Vie courante': 'Daily life',
			'Alltagsleben': 'Daily life',
			'Vita di ogni giorno': 'Daily life',
			'Vida cotidiana': 'Daily life',
			
			'Osobowość / charakter': 'Personality / character',
			'Personalità/carattere': 'Personality / character',
			'Personality / character': 'Personality / character',
			'Caracter personal': 'Personality / character',
			'Caractère de la personnalité': 'Personality / character',
			'Personalidade / personagem': 'Personality / character',
			'Persönlichkeit Charakter': 'Personality / character',
			
			'Życie towarzyskie': 'Social life',
			'Social life': 'Social life',
			'Vida social': 'Social life',
			'Vie sociale': 'Social life',
			'Soziales Leben': 'Social life',
			'Vita sociale': 'Social life',
			
			'Wyznawane wartości': 'Values / beliefs',
			'Values / beliefs': 'Values / beliefs',
			'Valores propugnados': 'Values / beliefs',
			'Valeurs adoptées': 'Values / beliefs',
			'Valores expostos': 'Values / beliefs',
			'Vertraute Werte': 'Values / beliefs',
			'Valori sposati': 'Values / beliefs',
			
			'Nałogi / nawyki': 'Habits / Addictions',
			'Habits / Addictions': 'Habits / Addictions',
			'Adicciones / hábitos': 'Habits / Addictions',
			'Dépendances / habitudes': 'Habits / Addictions',
			'Vícios / hábitos': 'Habits / Addictions',
			'Süchte / Gewohnheiten': 'Habits / Addictions',
			'Dipendenze/abitudini': 'Habits / Addictions',
			
			'Seks':'Sex',
			'Sex':'Sex',
			'Sexo':'Sex',
			'Sexe':'Sex',
			'Sesso':'Sex',

			'wpisz_imiona': 'Enter the names of both players',
			'wpisz_rozne_imiona': 'Enter names that differ from each other',
			'odblokowane': 'All levels have been unlocked. <br><br>Keep playing!',
			'jasny': 'Light',
			'ciemny': 'Dark',

			'blad_polaczenia': "Connection error. Please try again.",
			'przekaz_kod_gry': "Your game code",
			'przekaz_kod_gry_drugi_gracz': "You can also provide the game code for the second player",
"skanuj_kod_aparatem": "Scan the code with the camera",
  "wpisz_kod_recznie": "Enter the code manually",
  "wprowadz_kod": "Enter the received code",
  "wprowadz_kod_gry": "Enter the game code",
  "help8": "In the field below, enter the game code received from the second player. Once entered, the game will start automatically",
    "nieprawidlowy_kod_gry": "The code you entered is invalid",
"powrot_do_kategorii": "Back to categories"



       }